import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import ProductDropdown from "../pages/ProductDropdown";

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <nav className="bg-blue-700 text-white shadow-lg sticky top-0 z-[9999]">
            <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">

                {/* Logo (Mobile only) */}
                <h2 className="text-2xl font-bold tracking-wider md:hidden">
                    MDCC BANK
                </h2>

                {/* Desktop Menu */}
                <ul className="hidden md:flex gap-8 font-semibold items-center">

                    <NavItem to="/">HOME</NavItem>
                    <NavItem to="/about">ABOUT</NavItem>
                    <li><ProductDropdown /></li>
                    <NavItem to="/services">SERVICES</NavItem>
                    <NavItem to="/tender">TENDER</NavItem>
                    <NavItem to="/gallery">GALLERY</NavItem>
                    <NavItem to="/contact">CONTACT</NavItem>
                    <NavItem to="/downloads">DOWNLOADS</NavItem>
                </ul>

                {/* Desktop Right Link Button */}
                <div className="hidden md:flex ml-auto">
                    <a
                        href="https://mhwb7372.nivaran.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-white text-blue-700 px-3 sm:px-4 py-1 sm:py-2 rounded-md font-semibold
                                   hover:bg-blue-100 transition transform hover:scale-105 duration-200"
                    >
                        <img
                            src="images/Nivaran.webp"
                            alt="MHWB Logo"
                            className="w-5 h-5 sm:w-6 sm:h-6"
                        />
                        <span className="text-sm sm:text-base">NIVARAN-Customer Grievance Redressal</span>
                    </a>
                </div>

                {/* Mobile Menu Button */}
                <button className="md:hidden" onClick={() => setOpen(!open)}>
                    {open ? <X size={28} /> : <Menu size={28} />}
                </button>
            </div>

            {/* Mobile Dropdown */}
            {open && (
                <ul className="md:hidden flex flex-col gap-4 px-6 pb-6 pt-2 font-semibold bg-blue-700 text-white">

                    <MobileItem to="/" setOpen={setOpen}>HOME</MobileItem>
                    <MobileItem to="/about" setOpen={setOpen}>ABOUT</MobileItem>
                    <li><ProductDropdown /></li>
                    <MobileItem to="/services" setOpen={setOpen}>SERVICES</MobileItem>
                    <MobileItem to="/tender" setOpen={setOpen}>TENDER</MobileItem>
                    <MobileItem to="/gallery" setOpen={setOpen}>GALLERY</MobileItem>
                    <MobileItem to="/contact" setOpen={setOpen}>CONTACT</MobileItem>
                    <MobileItem to="/downloads" setOpen={setOpen}>DOWNLOADS</MobileItem>
                </ul>
            )}
        </nav>
    );
}

/* ----------------------------------- Reusable Desktop Nav Item ----------------------------------- */
function NavItem({ to, children }) {
    return (
        <li>
            <Link
                to={to}
                className="relative group"
            >
                <span className="transition duration-200 group-hover:text-black">
                    {children}
                </span>

                {/* Underline Effect */}
                <span className="
                    absolute left-0 bottom-[-4px] w-0 h-[2px] bg-white 
                    group-hover:w-full transition-all duration-300
                "></span>
            </Link>
        </li>
    );
}

/* ----------------------------------- Reusable Mobile Nav Item ----------------------------------- */
function MobileItem({ to, setOpen, children }) {
    return (
        <li>
            <Link
                to={to}
                onClick={() => setOpen(false)}
                className="block py-2 px-2 rounded-md hover:bg-blue-500 transition"
            >
                {children}
            </Link>
        </li>
    );
}
